export default {
    data(){
        return {
            refreshingInProgress: false,
            pendingRequests: [],
            pendingDatatables: [],
        }
    },
    methods: {
        updateRefreshToken: function (originalRequest){
            if (!this.refreshingInProgress) {
                // originalRequest._retry = true;
                this.refreshingInProgress = true;
                this.$store.dispatch('refreshToken').then((token) => {
                    //clearing all pending requests!
                    originalRequest.headers['Authorization'] = 'Bearer' + token;
                    this.onRefreshed();
                    this.pendingRequests = [];
                    // this.pendingDatatables = [];
                    this.refreshingInProgress = false;
                }).catch(() => {
                    this.$store.dispatch('logout').then(() => {
                        //session timeout for refresh token;
                        this.$router.replace("/");
                    });
                })
            }

            return new Promise(resolve => {
                if(originalRequest !== null) {
                    this.addNewPendingRequest(() => {
                        resolve(this.$http(originalRequest));
                    });
                }
            });
        },
        updateRefreshTokenInDataTable: function(dataTable){
            if(this.pendingRequests && this.pendingRequests.length === 0 && !this.refreshingInProgress)  {
                this.refreshingInProgress = true;
                this.$store.dispatch('refreshToken').then(() => {
                    dataTable.ajax.reload();
                    this.onRefreshed();
                    this.pendingRequests = [];
                    // this.pendingDatatables = [];
                    this.refreshingInProgress = false;
                }, () => {
                    this.$store.dispatch('logout').then(() => {
                        this.$router.replace("/");
                    });
                });
            }
        },
        addNewPendingRequest: function (request){
            this.pendingRequests.push(request);
        },
        onRefreshed: function (){
            this.pendingRequests.map(request => {
                request()
            });
        },
        showLoading: function (){
            Swal.fire({
                title: 'Please Wait! We are processing the data.',
                type: 'info',
                allowOutsideClick: false,
                allowEscapeKey: false,
                onBeforeOpen: () => {
                    Swal.showLoading();
                },
            });
        },
        showErrorMessage: function (ex){
            let message = ex;
            let error = (ex.response !== undefined) ? ex.response : ex
            if(error.data !== undefined && error.data.status !== undefined){
                message = (error.data.status === 400 || error.data.status === 404)
                    ? error.data.body[0]
                    : error.data.message
            }
            swal("Error!", message + "\nPlease try again or Contact DVM Tech Support", "error");
        },
        showLoadingOnDataTables: function (){
            let self = this;
            $(document).on({
                ajaxStart: function (){
                    self.showLoading();
                },
                ajaxStop: function (){
                    Swal.close();
                }
            });
        }
    }
}